import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import cohortsImg from "../../../../../assests/cohortsImg.svg"
const CohortSuccessComponent = (props) => {
  const { id } = useParams();  
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.iconWrapper}>
          <img 
            src={cohortsImg} 
            alt="Success Icon" 
            style={styles.icon}
          />
        </div>
        <h2 style={styles.message}>Cohort Created Successfully with ID: <span style={{fontWeight:"700"}}>{props.cohortId}</span> </h2>
        <p style={styles.thankYou}>Thank you</p>
        <button style={styles.button} onClick={() => navigate("/home/configuration/cohortslist")}>
          OK
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",  
    height: "100vh",
    backgroundColor: "#FFFFFF",
    paddingTop: "20px", 
    borderRadius:"24px" 
  },
  content: {
    textAlign: "center",
    padding: "20px",
    
  },
  iconWrapper: {
    marginBottom: "20px",
  },
  icon: {
    width: "280px",
    height: "280px",
    backgroundColor:"#fff"
  },
  message: {
    fontSize: "24px",
    color: "#14AE78",
  },
  thankYou: {
    fontSize: "18px",
    color: "#14AE78",
    marginBottom: "20px",
  },
  button: {
    padding: "10px 30px",
    backgroundColor: "#14AE78",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop:"70px"
  },
};

export default CohortSuccessComponent;
